var badenWurttembergQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Baden-Württemberg?',
    image: '301',
    answers: [
      {
        content: '1',
        key: 1,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Baden-Württemberg?',
    answers: [
      {
        content: 'Demmin',
        key: 0,
      },
      {
        content: 'Neckar-Odenwald-Kreis',
        key: 1,
      },
      {
        content: 'Nordfriesland',
        key: 0,
      },
      {
        content: 'Altötting',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Baden-Württemberg gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Baden-Württemberg bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Baden-Württemberg?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'schwarz-gold',
        key: 1,
      },
      {
        content: 'weiß-blau',
        key: 0,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Baden-Württemberg über politische Themen informieren?',
    answers: [
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'bei den Kirchen',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Baden-Württemberg heißt ...',
    answers: [
      {
        content: 'Heidelberg.',
        key: 0,
      },
      {
        content: 'Stuttgart.',
        key: 1,
      },
      {
        content: 'Karlsruhe.',
        key: 0,
      },
      {
        content: 'Mannheim.',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Baden-Württemberg?',
    image: '308',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 1,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Baden-Württemberg?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Baden-Württemberg',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Baden-Württemberg nicht?',
    answers: [
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
    ],
    category: 'Baden-Württemberg',
  },
]

export default badenWurttembergQuestions
